import { Button, Grid } from 'antd';
import { Modal } from 'components/modal/modal';
import { Filter } from 'lucide-react';
import { cloneElement, ReactElement, useEffect, useState } from 'react';

import {
  StyledButtonsWrapper,
  StyledFiltersModalWrapper,
  StyledFiltersWrapper,
  StyledFooterWrapper,
  StyledFormItemsWrapper,
} from './content-filters.styles';

type ContentFiltersProps = {
  formId?: string;
  children: ReactElement;
};

const { useBreakpoint } = Grid;

export const ContentFilters = ({ formId, children }: ContentFiltersProps) => {
  const screens = useBreakpoint();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (formId === 'week-view-filters-form') {
      setIsModalOpen(true);
    }
  }, []);

  return (
    <>
      {screens.lg ? (
        <StyledFiltersWrapper className='card filter_card'>
          {children}
        </StyledFiltersWrapper>
      ) : (
        <StyledFiltersModalWrapper className='mbl_flter'>
          <Button className='fltbtn' onClick={showModal}>
            <Filter /> Filter{' '}
          </Button>

          <Modal
            className='mbl_modal_center'
            open={isModalOpen}
            onCancel={closeModal}
            title={'Filter Heading'}
            getContainer={false}
            width='100%'
            footer={[
              <StyledFooterWrapper key='footer'>
                <StyledButtonsWrapper>
                  <Button
                    form={formId}
                    className='btn btn-primary'
                    key='modal-filters-submit'
                    htmlType='submit'
                    size={screens.lg ? 'middle' : 'large'}
                    type='primary'
                  >
                    Submit
                  </Button>
                  <Button
                    form={formId}
                    className='btn btn-default'
                    key='modal-filters-reset'
                    htmlType='reset'
                    size={screens.lg ? 'middle' : 'large'}
                  >
                    Reset
                  </Button>
                </StyledButtonsWrapper>
              </StyledFooterWrapper>,
            ]}
          >
            {cloneElement(children, { closeModal })}
          </Modal>
        </StyledFiltersModalWrapper>
      )}
    </>
  );
};

ContentFilters.ButtonsWrapper = StyledButtonsWrapper;
ContentFilters.FormItemsWrapper = StyledFormItemsWrapper;
